import { render, staticRenderFns } from "./BrandManageColors.vue?vue&type=template&id=3a0f60d0&"
import script from "./BrandManageColors.vue?vue&type=script&lang=ts&"
export * from "./BrandManageColors.vue?vue&type=script&lang=ts&"
import style0 from "./BrandManageColors.vue?vue&type=style&index=0&id=3a0f60d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports